(() => {
  const initSlider = (section) => {
    const box = section.querySelector(
      ".slideshow-wrapper[data-slider-type='type-1']"
    );
    if (!box) {
      return;
    }
    if (box) {
      const swiperParams = {
        slidesPerView: 1,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        autoHeight: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: false,
      };
      if (box.getAttribute("data-autoplay") === "true") {
        swiperParams.autoplay = {
          disableOnInteraction: true,
        };
      }
      if (box.getAttribute("data-loop") === "true") {
        swiperParams.loop = true;
        swiperParams.loopPreventsSliding = false;
      }
      const swiper = new Swiper(".slideshow__swiper-type-1", swiperParams);
      const nextBtn = document.querySelector(
        ".slideshow-nav-button-type-1--next"
      );
      const prevBtn = document.querySelector(
        ".slideshow-nav-button-type-1--prev"
      );
      const lock = () => {
        nextBtn.classList.add("is-disabled");
        prevBtn.classList.add("is-disabled");
        nextBtn.disabled = true;
        prevBtn.disabled = true;
      };
      const unlock = () => {
        nextBtn.classList.remove("is-disabled");
        prevBtn.classList.remove("is-disabled");
        nextBtn.disabled = false;
        prevBtn.disabled = false;
      };
      nextBtn.addEventListener("click", () => {
        if (swiper.animating) return;
        lock();
        swiper.slideNext();
      });
      prevBtn.addEventListener("click", () => {
        if (swiper.animating) return;
        lock();
        swiper.slidePrev();
      });
      swiper.on("transitionEnd", () => {
        unlock();
      });
    }
  };
  const autofitText = () => {
    const vminSize =
      (67 * Math.min(window.innerWidth, window.innerHeight)) / 100;
    const maxFontSize = Math.min(vminSize, 550);
    document.querySelectorAll(".slideshow-text").forEach((el) => {
      const originalStyles = {
        whiteSpace: el.style.whiteSpace,
        display: el.style.display,
      };
      el.style.whiteSpace = "nowrap";
      el.style.display = "inline-block";
      el.style.setProperty("--autoFontSize", el.parentElement.offsetWidth / 2);
      const computedStyle = getComputedStyle(el);
      const visibleWidth = parseFloat(computedStyle.width);
      const visibleHeight = parseFloat(computedStyle.height);
      const widthRatio = visibleWidth / el.scrollWidth;
      const heightRatio = visibleHeight / el.scrollHeight;
      const fixRatio = Math.min(widthRatio, heightRatio);
      let desiredFontSize = (el.parentElement.offsetWidth * fixRatio) / 2;
      desiredFontSize = Math.min(desiredFontSize, maxFontSize);
      el.style.setProperty("--autoFontSize", desiredFontSize);
      const finalWidth = el.scrollWidth;
      const finalHeight = el.scrollHeight;
      if (finalWidth > visibleWidth || finalHeight > visibleHeight) {
        const safetyRatio = Math.min(
          visibleWidth / finalWidth,
          visibleHeight / finalHeight
        );
        const safeFontSize = desiredFontSize * safetyRatio * 0.95;
        el.style.setProperty(
          "--autoFontSize",
          Math.min(safeFontSize, maxFontSize)
        );
      }
      el.style.whiteSpace = originalStyles.whiteSpace;
      el.style.display = originalStyles.display;
      autofitContainers.add(el.parentElement);
      const wrapper = el.closest(".slideshow");
      const slideshowTextWrapperHeight = wrapper.querySelector(
        ".slideshow-text-wrapper"
      )?.offsetHeight;
      const sliderWrapper = wrapper.querySelector(".slider-wrapper");
      if (sliderWrapper) {
        sliderWrapper.style.setProperty(
          "--text-wrapper-height",
          `${slideshowTextWrapperHeight}px`
        );
      }
    });
  };
  const [onloadOld, onresizeOld, autofitContainers] = [
    window.onload,
    window.onresize,
    new Set(),
  ];
  window.onresize = () => {
    if (onresizeOld) onresizeOld();
    autofitText();
  };
  window.onload = () => {
    if (onloadOld) onloadOld();
    autofitText();
    autofitContainers.forEach((c) =>
      new MutationObserver((ms) => {
        autofitText();
      }).observe(c, {
        attributes: true,
        attributeFilter: ["style"],
      })
    );
  };
  autofitText();
  initSlider(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    autofitText();
    initSlider(event.target);
  });
})();
